
import { MODULE } from "@/config/modules";
import { AuthService, DossierConfigService } from "@/services";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMissingModule from "@/components/common/MissingModule.vue";
import {CarpassService} from "@/services/carpass-service";

export default Vue.extend({
	data(){
		return {
			carpassConfig: DossierConfigService.getCarpassConfig(),
			saving: false,
		};
	},
	computed: {
		path(): any[] {
			return [{
				to: "/settings/plugins", value: this.$ct("plugins")
			},      {value: this.$ct("car")}] as IBreadCrumb[];
		},
		carpassModule():MODULE{
			return MODULE.CARPASS;
		},
		hasCarpass():boolean {
			return AuthService.hasModule(this.carpassModule);
		},
		saveDisabled():boolean {
			if (this.saving) return true;
			if (this.carpassConfig.Username && !this.carpassConfig.KboNumber) return true;
			if (this.carpassConfig.KboNumber && !this.carpassConfig.Username) return true;
			if (!this.isKboNumberValid) return true;
			return false;
		},
		isKboNumberValid():boolean{
			return this.carpassConfig.KboNumber.length <= 10;
		}
	},
	methods: {
		async saveCarpass(){
			if (this.saving) return;
			try{
				this.saving = true;
				if (this.carpassConfig.Username) {
					await CarpassService.test(this.carpassConfig.Username, this.carpassConfig.Password);
				}
				await DossierConfigService.setCarpassConfig(this.carpassConfig);
				this.$wf.notify(this.$ct("save-success"), "success", 3000, "check");
			}catch(err){
			}finally{
				this.saving = false;
			}
		}
	},
	components: {
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
